import BaseChange from "./BaseChange"

export default class ErrorOccured extends BaseChange {
  constructor(error) {
    super()
    this.type = "errorOccured"
    this.error = error
  }
}
